import Spinner from "../common/Spinner";

import "./page-loader.scss";

export default function PageLoader({ message }) {
  return (
    <div>
      <div className="loader-backdrop"></div>
      <div className="loader-container d-flex flex-column justify-content-center">
        <Spinner
          size="lg"
          className="text-center"
          message={message ? message : "Loading..."}
        />
      </div>
    </div>
  );
}
